import React, { useState } from 'react';

import { cn } from '@/lib/utils';
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select';

import { MessageSquareDot } from 'lucide-react';

import AddNewLocationDialog from '@/components/dialog/AddNewLocationDialog';

export function AccountSwitcher({
	businessGroup,
	isEnterpriseEnabled,
	handleSwitchLocation,
	auth,
}) {
	const [showAddNewLocationDialog, setShowAddNewLocationDialog] =
		useState(false);

	const changeLocation = (val) => {
		if (val === 'open_dialog') {
			setShowAddNewLocationDialog(true);
			return;
		}

		handleSwitchLocation({ _id: val });
	};

	const { reseller } = auth;

	return (
		<>
			<Select
				defaultValue={(isEnterpriseEnabled && 'ALL_LOCATIONS') || auth}
				onValueChange={changeLocation}
				value={
					(isEnterpriseEnabled && 'ALL_LOCATIONS') ||
					(auth && auth._id)
				}
			>
				<SelectTrigger
					className={cn('flex w-60 items-center')}
					aria-label="Select account"
				>
					<SelectValue placeholder="Select an location">
						<span className={cn('ml-2')}>
							{isEnterpriseEnabled
								? 'All Locations'
								: businessGroup.find(
										(business) => business._id === auth._id
								  )?.name}
						</span>
					</SelectValue>
				</SelectTrigger>
				<SelectContent>
					{businessGroup && businessGroup.length > 0 && (
						<SelectItem
							key={'ALL-LOCATIONS'}
							value={'ALL-LOCATIONS'}
						>
							<div className="flex items-center gap-3 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0 [&_svg]:text-primary">
								All Locations
							</div>
						</SelectItem>
					)}
					{[...businessGroup]
						.sort((a, b) => {
							const nameA = (a.name || '').toString();
							const nameB = (b.name || '').toString();
							return nameA.localeCompare(nameB);
						})
						.map((business) => (
							<SelectItem key={business._id} value={business._id}>
								<div className="flex items-center gap-3 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0 [&_svg]:text-primary">
									{business._id !== auth._id &&
										business.hasUnreadMessages && (
											<MessageSquareDot />
										)}
									{business.name}
									{`: `}
									{business.address}
								</div>
							</SelectItem>
						))}
					{!reseller && (
						<SelectItem key={'open_dialog'} value={'open_dialog'}>
							<div className="flex items-center gap-3 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0 [&_svg]:text-foreground">
								Add an additional location
							</div>
						</SelectItem>
					)}
				</SelectContent>
			</Select>
			<AddNewLocationDialog
				handleClose={() => setShowAddNewLocationDialog(false)}
				isOpen={showAddNewLocationDialog}
				handleSwitchLocation={handleSwitchLocation}
			/>
		</>
	);
}
